import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import { useQueryClient } from 'react-query'
// import { useLocation } from 'react-router-dom'

import AuthApi from 'api/auth.api'
import { queryKeys } from 'queries/queryKeys'
import { QUERY_KEYS } from '___queries'

export const useLogout = () => {
  const queryClient = useQueryClient()
  const dispatch = useDispatch()
  const { push } = useHistory()
  // const tenant = 'viseca' // dev

  const logout = useCallback(async () => {
    await AuthApi.logoutUser()
    queryClient.invalidateQueries(queryKeys.USER)
    queryClient.invalidateQueries(QUERY_KEYS.USER)
    queryClient.invalidateQueries()
    queryClient.clear()
    localStorage.clear()
    AuthApi.setAuthHeaders(null, null)
    push('/auth/login')
    dispatch({ type: 'LOGOUT' })
  }, [push, queryClient, dispatch])

  return logout
}

